export default __webpack_public_path__ + "static/media/FacturationIcon.7affae6f.svg";